function HalalMeat() {
   return (
    
      <div className="page-container">
          <h1 className="page-title">Halal Meat</h1>

          <div className="page-content">
            <p>
            To be updated!
            </p>

          </div>
        </div>

  );
}
export default HalalMeat;